import script from "./MobileCollegePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileCollegePage.vue?vue&type=script&lang=ts&setup=true"

import "./MobileCollegePage.vue?vue&type=style&index=0&id=db9016a4&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db9016a4"]])

export default __exports__